// Pointer-driven hover details, mouse only (touch and pen never trigger them):
//   • .a1-spot panels get a soft mint light that follows the cursor (--mx/--my).
//   • The hero's metal A shifts a few pixels against the cursor (--tx/--ty),
//     skipped when the visitor prefers reduced motion.
// One delegated listener for the whole app; work is batched into a frame.

const HERO_SHIFT_PX = 12;

export function installPointerEffects() {
  if (typeof window === "undefined" || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let frame = 0;
  let last: PointerEvent | null = null;
  let heroMark: HTMLElement | null = null;

  const resetHero = () => {
    heroMark?.style.removeProperty("--tx");
    heroMark?.style.removeProperty("--ty");
    heroMark = null;
  };

  const apply = () => {
    frame = 0;
    const event = last;
    if (!event || !(event.target instanceof Element)) return;

    const spot = event.target.closest<HTMLElement>(".a1-spot");
    if (spot) {
      const box = spot.getBoundingClientRect();
      spot.style.setProperty("--mx", `${event.clientX - box.left}px`);
      spot.style.setProperty("--my", `${event.clientY - box.top}px`);
    }

    const hero = event.target.closest<HTMLElement>(".a1-hero");
    const mark = hero?.querySelector<HTMLElement>(".a1-hero-mark") ?? null;
    if (!hero || !mark || reducedMotion.matches) { resetHero(); return; }
    const box = hero.getBoundingClientRect();
    const x = (event.clientX - box.left) / box.width - .5;
    const y = (event.clientY - box.top) / box.height - .5;
    heroMark = mark;
    mark.style.setProperty("--tx", `${(-x * HERO_SHIFT_PX).toFixed(1)}px`);
    mark.style.setProperty("--ty", `${(-y * HERO_SHIFT_PX).toFixed(1)}px`);
  };

  document.addEventListener("pointermove", event => {
    if (event.pointerType !== "mouse") return;
    last = event;
    if (!frame) frame = requestAnimationFrame(apply);
  }, { passive: true });
  document.documentElement.addEventListener("pointerleave", resetHero);
}
